import { type ChangeEvent, useCallback, useState } from 'react';

export const useRecoveryCodeApi = () => {
	const [recoveryCodeValue, setRecoveryCodeValue] = useState<string>('');

	const handleRecoveryCodeValue = useCallback((e: ChangeEvent<HTMLInputElement>) => {
		setRecoveryCodeValue(e.target.value);
	}, []);

	return {
		recoveryCodeValue,
		handleRecoveryCodeValue,
		setRecoveryCodeValue,
	};
};
